import { render, staticRenderFns } from "./ThankYouTakeOut.vue?vue&type=template&id=5871d9f1&scoped=true&"
import script from "./ThankYouTakeOut.vue?vue&type=script&lang=js&"
export * from "./ThankYouTakeOut.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouTakeOut.vue?vue&type=style&index=0&id=5871d9f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871d9f1",
  null
  
)

export default component.exports